import React, { Component } from 'react';


import Education from './Education';
import Health from './Health';
import FoodShop from './FoodShop';
import General from './General';

import Sources from '../f-Utilities/Sources'

class Activities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: "education",
    };
  }

  select = (selection) => {
    this.setState({selected: selection})
  }

  render() {
    return(
          <div className="row content mt-5 mb-5">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">activités</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 line-border">
                    <p
                    className={this.state.selected === "education" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                       onClick={this.select.bind(this, "education")}>éducation </p>
                     <p
                     className={this.state.selected === "health" ?
                       "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                        onClick={this.select.bind(this, "health")}>santé </p>
                     <p
                     className={this.state.selected === "food" ?
                       "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                        onClick={this.select.bind(this, "food")}>commerces alimentaires</p>
                      <p
                      className={this.state.selected === "general" ?
                        "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                         onClick={this.select.bind(this, "general")}>pôles de commerces et services</p>

                  </div>

                </div>
            </div>

            <div className="col-9">
                {this.state.selected == "education" ? <Education territory={this.props.territory} id="education_detailed" /> :
                 this.state.selected == "food" ? <FoodShop territory={this.props.territory} id="food_shop_detailed" /> :
                 this.state.selected == "health" ? <Health territory={this.props.territory} id="health_detailed" /> :
                <General territory={this.props.territory} id="general_detailed" />
              }

              <div className="row mt-1">
                <div className="col-10">
                 <Sources sources={this.props.territory.sources}
                        concerned={["dossier_complet", "gridded_pop", "bpe", "education_data_gouv"]}/>
                </div>
              </div>
            </div>

          </div>
    )
  }
}

export default Activities;
